<div class="container" [class.is-mobile]="mobileQuery.matches">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      #sideNav
      opened="false"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="50"
    >
      <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content class="class-for-infinite-scroll">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
